import React, { useState } from "react";
import { VideoGallery, GalleryWithDescription } from "../";
import { MediaContainer, MediaSwitchDesktopContainer, MediaSwitchHeader, } from "./MediaSwitchDesktopStyled";
export var MediaSwitchDesktop = function (_a) {
    var _b;
    var product = _a.product, selected = _a.selected;
    var _c = useState((_b = selected === null || selected === void 0 ? void 0 : selected.type) !== null && _b !== void 0 ? _b : "imagen"), view = _c[0], setView = _c[1];
    var selectView = function (selected) {
        setView(selected);
    };
    var getView = function () {
        switch (view) {
            case "imagen":
                var imageSelected = selected.type === "imagen" ? selected : null;
                return (React.createElement(GalleryWithDescription, { product: product, selected: imageSelected }));
            case "video":
                var videoSelected = selected.type === "video" ? selected : null;
                return React.createElement(VideoGallery, { product: product, selected: videoSelected });
        }
    };
    return (view && (React.createElement(MediaSwitchDesktopContainer, null,
        React.createElement(MediaSwitchHeader, null,
            product.multimedia.filter(function (m) { return m.type === "video"; }).length > 0 && (React.createElement("li", { className: view === "video" ? "selected" : "", onClick: function () { return selectView("video"); } }, "VIDEOS")),
            React.createElement("li", { className: view === "imagen" ? "selected" : "", onClick: function () { return selectView("imagen"); } }, "IM\u00C1GENES"),
            React.createElement("li", { className: "fill-empty-space" })),
        React.createElement(MediaContainer, null, getView()))));
};
